import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/diveAN/step4';
import { Annulation } from '../models/Annulation';
@Component({
  selector: 'app-annulation',
  templateUrl: './annulation.component.html'
})
export class AnnulationComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Annulation'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() annulation : Annulation;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() {
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

